import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import swal from "sweetalert";
import "./Costs.css"

import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import DropDown from '../../Components/DropDown/DropDown';
import Input from '../../Components/Input/Input';
import Message from '../../Components/Message/Message';
import Modal from '../../Components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import { formatDate } from "../../utils/Helper";

import { MdDeleteOutline, MdDateRange } from "react-icons/md";
import { AiOutlineEdit } from "react-icons/ai";
import { FaEye } from "react-icons/fa";
import { BsFilterLeft } from "react-icons/bs";
import { IoMdArrowDropdown, IoMdAdd } from "react-icons/io";
import { FaDownload } from "react-icons/fa6";


import { get_all_costs, create_costs, update_cost, delete_costs } from "../../context/Services/Costs";

const Costs = () => {
	const navigate = useNavigate();
	const { t } = useTranslation();

	const [showFrom, setShowFrom] = useState(false);
	const [from, setFrom] = useState({
		date: new Date(),
		monthNum: new Date().getMonth() + 1
	});

	const [showModal, setShowModal] = useState(false);
	const [costs, setCosts] = useState([]);
	const [status, setStatus] = useState(false);
	const [loading, setLoading] = useState(true);
	const [isUpdating, setIsUpdating] = useState(false);

	const intial_payload = {
		supplier_name: "",
		amount: 0,
		description: "",
		note: "",
		cost_date: Date.now(),
	}
	const [payload, setPayload] = useState(intial_payload);
	const [file, setFile] = useState(null);

	const get_form_data = () => {
		const formData = new FormData();
		if (file) {
			formData.append("file_path", file);
		}


		for (const key in payload) {
			if (Array.isArray(payload[key])) {

				formData.append(key, JSON.stringify(payload[key]));
			} else if (payload[key] instanceof Date) {

				formData.append(key, payload[key].toISOString());
			} else {

				formData.append(key, payload[key]);
			}
		}

		return formData
	}

	const handle_get_costs = () => {
		get_all_costs(from)
			.then(res => {
				setCosts(res?.data);
			})
			.catch(e => {
				console.log(e);
			})
	}

	const handle_delete_costs = async (id) => {
		const willDelete = await swal({
			title: "Es-vous sûr ?",
			text: t("Est ce que vous voulez vraiment supprimer ?"),
			icon: "warning",
			buttons: true,
			dangerMode: true,
		});

		if (willDelete) {
			delete_costs(id)
				.then(res => {
					handle_get_costs();
					setTimeout(() => {
						setStatus(false);
					}, 1500)
				})
				.catch(e => setStatus(false));
		}
	}

	const handle_update_costs = async () => {
		const willUpdate = await swal({
			title: "Es-vous sûr ?",
			text: t("Est ce que vous voulez vraiment confirmer ?"),
			icon: "warning",
			buttons: true,
			dangerMode: true,
		});

		let form_data = get_form_data();

		if (willUpdate) {
			update_cost(payload?._id, form_data)
				.then(res => {
					setPayload(intial_payload);
					setShowModal(false)
					setIsUpdating(false);
					setStatus(false);
					handle_get_costs();
				})
				.catch(e => {
					setStatus(false);
					setIsUpdating(false);
				});
		}
	}

	const handle_add_costs = async () => {
		setStatus(true);

		let form_data = get_form_data();

		create_costs(form_data)
			.then(res => {
				setShowModal(false);
				handle_get_costs();
				setStatus(false);
				setPayload(intial_payload)
			})
			.catch(e => setStatus(false));
	}

	const download_file = async (link, filename) => {
		const fileUrl = link;

		try {

			const response = await fetch(fileUrl);
			if (!response.ok) {
				throw new Error('Network response was not ok');
			}

			const blob = await response.blob();

			const blobUrl = window.URL.createObjectURL(blob);

			const link = document.createElement('a');
			link.href = blobUrl;

			const download_date = new Date().toISOString().split('T')[0];
			link.download = `${filename}_${download_date}`;

			document.body.appendChild(link);
			link.click();

			link.remove();
			window.URL.revokeObjectURL(blobUrl);

		} catch (error) {
			console.error('Error downloading the file:', error);
		}
	};

	useEffect(() => {
		handle_get_costs();
	}, [])

	useEffect(() => {
		if (from) {
			handle_get_costs();
		}
	}, [from])

	return (
		<>
			<Message loading={status} status={{ status: status }} />

			<Modal showBakcDrop={showModal} modal={showModal} hideModal={() => { setShowModal(false); setPayload(intial_payload) }} className="auto_width">
				<div className="grid full">
					<div className="flex flex-col full relative" style={{ gap: "10px" }}>
						<h5>{t("Nome de frais")}</h5>
						<Input
							placeholder="Nome de frais"
							setChange={(e) => {
								setPayload(prev => ({ ...prev, cost_name: e }))
							}}
							value={payload.cost_name}
						/>
					</div>

					<div className="flex flex-col full" style={{ gap: "10px" }}>
						<h5>{t("Amount")}</h5>
						<Input
							placeholder="Amount"
							setChange={(e) => setPayload(prev => ({ ...prev, amount: e }))}
							value={payload.amount}
						/>
					</div>

					<div className="flex flex-col full" style={{ gap: "10px", padding: "0px 0" }}>
						<h5>{t("Description")}</h5>
						<Input
							placeholder="description"
							setChange={(e) => setPayload(prev => ({ ...prev, description: e }))}
							value={payload.adresse}
						/>
					</div>

					<div className="flex flex-col full" style={{ gap: "10px", padding: "0px 0" }}>
						<h5>{t("Note")}</h5>
						<Input
							placeholder="Note"
							setChange={(e) => setPayload(prev => ({ ...prev, note: e }))}
							value={payload.note}
						/>
					</div>

					<div className="flex flex-col full" style={{ gap: "10px", padding: "0px 0" }}>
						<h5>{t("Date")}</h5>
						<Input
							type="date"
							placeholder="Date"
							setChange={(e) => setPayload(prev => ({ ...prev, cost_date: e }))}
							value={payload.cost_date}
						/>
					</div>

					<div className="flex flex-col full" style={{ gap: "10px", padding: "0px 0" }}>
						<h5>{t('File')}</h5>
						<input type="file" id="cost_file_upload" style={{ display: 'none' }} onChange={(event) => setFile(event?.target.files[0])} />
						<div
							className="flex justify-center items-center cost_file_input pointer"
							onClick={() => document.getElementById('cost_file_upload').click()}
						>
							<span style={{ color: file ? '#333' : '#888', fontSize: '0.85rem' }}>
								{file ? file.name : t('Choisir un fichier')}
							</span>
						</div>
					</div>

					<button
						className="filter_button full pointer two_span"
						onClick={isUpdating ? handle_update_costs : handle_add_costs}
						style={{ paddingTop: '10px', paddingBottom: "10px" }}
					>
						{t("Confirm")}
					</button>

				</div>
			</Modal>

			<div className="clients_overview latest_clients_overview shadow">
				<div className="chart_section_header flex items-center">
					<b>{t("Les frais overview")}</b>

					<div className='relative to-right flex gap'>

						<DatePicker
							selected={from.date}
							onChange={(date) => setFrom({ monthNum: date.getMonth() + 1, date: date })}
							dateFormat="MMMM yyyy"
							showMonthYearPicker
							customInput={
								<div className="flex gap items-center filter_button">
									<MdDateRange style={{ color: "#7983ff", fontSize: '1.2rem' }} />
								</div>
							}
						/>

						{/*<div className="flex gap items-center filter_button relative"
								onMouseEnter={()=>setShowFrom(true)} 
							      onMouseLeave={()=>setShowFrom(false)}
							>
								<MdDateRange style={{color:"#7983ff", fontSize:'1.2rem'}}/>
								<b>
									{
										from?.from && from?.to
										? from?.from?.toISOString().split("T")[0] + "|  -  |" + from?.to?.toISOString().split("T")[0]
										: t("Filter by date")
									}
								</b>
								{console.log("from",from)}
								<DayPicker
								  className={`calendar ${showFrom && "show"}`}
							      mode="range"
							      selected={from}
							      onSelect={setFrom}
							    />
							</div>*/}

						<div className="flex gap items-center filter_button" onClick={() => {
							setShowModal(!showModal);
							setIsUpdating(false)
						}}>
							<IoMdAdd style={{ color: "#7983ff", fontSize: '1.2rem' }} />
							<b>{t("Ajouter un Frais")}</b>
						</div>

					</div>
				</div>

				<div className="flex flex-col gap summary_clients_section">
					<div className="flex gap">
						<div className="flex gap total_div  ml_15 mt_-10">
							<p>{t("Total Value")}</p>
							<b>{costs.reduce((acc, curr) => acc + curr?.amount, 0)} {t("MAD")}</b>
						</div>
					</div>
					<div className="table_section table_section_overwrite">
						<table cellPadding="0" cellSpacing="0">
							<tbody>

								<td className="table-keys cell2 pointer">{t("Nome de frais")}</td>
								<td className="table-keys cell2 pointer">{t("Amount")}</td>
								<td className="table-keys cell2 pointer">{t("Description")}</td>
								<td className="table-keys cell2 pointer">{t("Note")}</td>
								<td className="table-keys cell2 pointer">{t("Date")}</td>
								<td className="table-keys cell2 pointer">{t("Action")}</td>

								{
									costs?.length > 0 &&
									costs.map((elem, i) => (
										<tr className={`data-cells`}>
											<td className={`value2 cell2  `} >{elem?.cost_name}</td>
											<td className={`value2 cell2  `} >{elem?.amount} {t("MAD")}</td>
											<td className={`value2 cell2  `} >{elem?.description !== "" ? elem?.description : elem?.description}</td>
											<td className={`value2 cell2  `} >{elem?.note !== "" ? elem?.note : "-"}</td>
											<td className={`value2 cell2  `} >{formatDate(elem?.cost_date)}</td>
											<td className={`value2 cell2 action`}>
												<div className="flex gap_5 justify-center">
													<MdDeleteOutline className="action_btn delete" onClick={() => handle_delete_costs(elem?._id)} />
													<AiOutlineEdit className="action_btn edit" onClick={() => {
														setPayload(elem);
														setShowModal(true);
														setIsUpdating(true);
													}} />
													{
														elem?.file && <FaDownload className="action_btn download" onClick={() => download_file(elem?.file, elem?.cost_name)} />
													}
												</div>
											</td>
										</tr>
									))
								}


							</tbody>
						</table>
					</div>

				</div>
			</div>
		</>
	)
}

export default Costs